import { registerLocaleData } from '@angular/common';
import localeAU from '@angular/common/locales/en-AU';
import localeCA from '@angular/common/locales/en-CA';
import localeNZ from '@angular/common/locales/en-NZ';
import localeAUExtra from '@angular/common/locales/extra/en-AU';
import localeCAExtra from '@angular/common/locales/extra/en-CA';
import localeNZExtra from '@angular/common/locales/extra/en-NZ';

export const SupportedLocales = ['en-AU', 'en-NZ', 'en-US', 'en-CA'];

let locale = 'en-AU';

export function getLocale(): string {
	registerLocaleData(localeAU, 'en-AU', localeAUExtra);
	registerLocaleData(localeNZ, 'en-NZ', localeNZExtra);
	registerLocaleData(localeCA, 'en-CA', localeCAExtra);

	if (navigator && navigator.languages) {
		locale = navigator.languages.find(x => SupportedLocales.includes(x)) || locale;
	}
	return locale;
}
